var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout md-gutter",class:[{ 'third-gallery' : _vm.numberOfItems===3}],attrs:{"id":"lazy-gallery"}},_vm._l((_vm.numberOfItems),function(item){return _c('SLazyCard',{key:item})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }